export const Breaker = () => <div
  className='border border-t-2 border-b-0 border-x-0 border-dotted w-[90%] border-secondary'
/>;